<template>
	<div class="teacher-container">
		<div class="teacher-title">
			<span>个人信息</span>
			<span class="flex-empty"></span>
			<a-button v-if="isManager && teacherInfoId" class=" m-right-20" type="danger" icon="delete" @click="delTeacherHandle">删除</a-button>
			<div v-if="teacherInfoId && canUpdate">
				<a-button v-if="!isEditTeacher" icon="edit" @click="isEditTeacher = true">编辑</a-button>
				<a-button v-if="isEditTeacher" @click="resetTeacherInfo">取消</a-button>
				<a-button type="primary" v-if="isEditTeacher" class="m-left-20" @click="submitHandle" :loading="loading"
					:disabled="!hasTeacherInfoChange">提交</a-button>
			</div>
		</div>
		<div class="teacher-info teacher-info_edit" v-if="teacherInfoId && !isEditTeacher">
			<div class="dis-line teacher-item">
				<span class="teacher-item_label">姓名</span>
				<span class="teacher-item_value">{{ teacherDetail.name || "--" }}</span>
			</div>

			<div class="dis-line teacher-item m-left-100">
				<span class="teacher-item_label">手机号</span>
				<span class="teacher-item_value">{{ teacherDetail.mobile || "--" }}</span>
				<span class="teacher-matched" v-if="isManager && matchedUser">手机号匹配用户：{{ matchedUser.name }}</span>
				<span class="teacher-unmatched" v-if="isManager && !matchedUser">{{ tips }}</span>
			</div>
			<br />
			<div class="dis-line teacher-item">
				<span class="teacher-item_label">性别</span>
				<span class="teacher-item_value">{{ GENDER_MAP[teacherDetail.gender] || "--" }}</span>
			</div>
			<div class="dis-line teacher-item m-left-100">
				<span class="teacher-item_label">最高学历</span>
				<span class="teacher-item_value">{{ EDUCATION_LEVEL[teacherDetail.education_level] || "--" }}</span>
			</div>
			<br />
			<div class="dis-line teacher-item">
				<span class="teacher-item_label">出生日期</span>
				<span class="teacher-item_value" v-if="teacherDetail.birth_date">{{
					teacherDetail.birth_date |
						timeFormat
				}}</span>
				<span class="teacher-item_value" v-else>--</span>
			</div>
			<div class="dis-line teacher-item m-left-100">
				<span class="teacher-item_label">入职日期</span>
				<span class="teacher-item_value" v-if="teacherDetail.entry_date">{{
					teacherDetail.entry_date |
						timeFormat
				}}</span>
				<span class="teacher-item_value" v-else>--</span>
			</div>
			<br />
			<div class="dis-line teacher-item">
				<span class="teacher-item_label">职称</span>
				<span class="teacher-item_value">{{ teacherDetail.professional_title || "--" }}</span>
			</div>
			<div class="dis-line teacher-item m-left-100">
				<span class="teacher-item_label">是否有教资</span>
				<span class="teacher-item_value">{{ teacherDetail.has_teacher_qualification ? "有" : "无" }}</span>
			</div>
		</div>

		<div class="teacher-info" v-else>
			<div class="dis-line">
				<span class="teacher-label required-field">姓名</span>
				<a-input class="teacher-input" @blur="checkDuplicateHandle" v-model="teacherDetail.name" placeholder="请输入老师姓名" />
				<!-- <span class="teacher-matched" v-if="isManager && matchedUser">手机号匹配用户：{{ matchedUser.name }}</span> -->
			</div>
			<div class="dis-line m-left-100">
				<span class="teacher-label required-field">手机号</span>
				<a-input class="teacher-input" v-model="teacherDetail.mobile" :disabled="!isManager"
					placeholder="请输入手机号" @blur="getMatchedTeacherUser('init')" />
				<span class="teacher-matched" v-if="isManager && matchedUser">手机号匹配用户：{{ matchedUser.name }}</span>
				<span class="teacher-unmatched" v-if="isManager && !matchedUser">{{ tips }}</span>
			</div>
			<br />
			<div class="dis-line">
				<span class="teacher-label">性别</span>
				<a-select class="teacher-input" v-model="teacherDetail.gender" placeholder="请选择性别">
					<a-select-option value="MALE" key="MALE">男</a-select-option>
					<a-select-option value="FEMALE" key="FEMALE">女</a-select-option>
				</a-select>
			</div>
			<div class="dis-line m-left-100">
				<span class="teacher-label">最高学历</span>
				<a-select class="teacher-input" v-model="teacherDetail.education_level" placeholder="请选择最高学历">
					<a-select-option v-for="(value, key) in EDUCATION_LEVEL" :value="key" :key="key">
						{{ value }}
					</a-select-option>
				</a-select>
			</div>
			<br />
			<div class="dis-line">
				<span class="teacher-label">出生日期</span>
				<a-date-picker class="teacher-input" v-model="teacherDetail.birth_date" placeholder="请选择出生日期" />
			</div>
			<div class="dis-line m-left-100">
				<span class="teacher-label">入职日期</span>
				<a-date-picker class="teacher-input" v-model="teacherDetail.entry_date" placeholder="请选择入职日期" />
			</div>
			<br />
			<div class="dis-line">
				<span class="teacher-label">职称</span>
				<a-input class="teacher-input" v-model="teacherDetail.professional_title" placeholder="请输入老师职称" />
			</div>
			<div class="dis-line m-left-100">
				<span class="teacher-label">是否有教资</span>
				<a-radio-group name="radioGroup" v-model="teacherDetail.has_teacher_qualification">
					<a-radio :value="true">有</a-radio>
					<a-radio :value="false">无</a-radio>
				</a-radio-group>
			</div>
		</div>

		<div class="teacher-title">
			<span>任教信息</span>
			<span class="flex-empty"></span>
			<a-button v-if="isManager" class="fr" icon="edit" @click="clickHandle">添加任教班级</a-button>
			<a-button v-if="isManager && teacherInfoId" type="primary" class="fr m-left-20"
				:disabled="!hasTeacherChange" @click="createKlassTeacherHandle">提交</a-button>
		</div>
		<div class="teacher-kinsfolk">
			<div v-for="(item, index) in klassTeacherList" :key="index">
				<div v-if="item.id">
					<div class="dis-line teacher-item">
						<span class="teacher-item_label">任教班级</span>
						<span class="teacher-item_value">{{ item.klass_name || "--" }}</span>
					</div>
					<div class="dis-line m-left-100">
						<span class="teacher-item_label">任教职务</span>
						<span class="teacher-item_value">{{ item.role_name || "--" }}</span>
					</div>
					<span class="teacher-operate teacher-del m-top-10"
						@click="deactivateKlassTeacherHandle(item, index)" v-if="showDelete">
						<a-icon type="delete" />
					</span>
				</div>
				<div v-else>
					<div class="dis-line">
						<span class="teacher-label required-field">任教班级<span class="teacher-error">{{
							item.klassMessage
						}}</span></span>
						<a-select class="teacher-input" v-model="item.klass_id" placeholder="请选择班级">
							<a-select-option v-for="item in curKlassList" :value="item.id" :key="item.id">
								{{ item.name }}
							</a-select-option>
						</a-select>
					</div>
					<div class="dis-line m-left-100">
						<span class="teacher-label required-field">任教职务<span class="teacher-error">{{
							item.roleMessage
						}}</span></span>
						<a-select class="teacher-input" v-model="item.role_id" placeholder="请选择职务">
							<a-select-option v-for="item in roleList" :value="item.id" :key="item.id">
								{{ item.name }}
							</a-select-option>
						</a-select>
					</div>
					<span class="teacher-operate teacher-del m-top-50"
						@click="deactivateKlassTeacherHandle(item, index)" v-if="showDelete">
						<a-icon type="delete" />
					</span>
				</div>
				<div class="teacher-deliver" v-if="klassTeacherList.length > 1 && index != klassTeacherList.length - 1">
				</div>
			</div>
			<a-empty class="p-top-30" v-if="!klassTeacherList.length" />
		</div>
		<a-button class="submit-btn" @click="submitHandle" :loading="loading" v-if="canUpdate && !teacherInfoId">确定</a-button>
	</div>
</template>
  
<script>
import { mapGetters } from "vuex"
import TeacherInfoService from "@/api/teacherService"
import userService from "@/api/userService"
import dict from "@/config"

export default {
  name: "teacher",
  components: {},
  data() {
    return {
      teacherInfoId: undefined,
      loading: false,
      teacherDetail: {},
      originTeacherDetail: {},
      klassTeacherList: [],
      roleList: [],
      EDUCATION_LEVEL: dict.EDUCATION_LEVEL,
      GENDER_MAP: dict.GENDER_MAP,
      matchedUser: null,
      tips: undefined,
      curKlassList: [],
      teacherId: undefined,
      isEditTeacher: false,
      teacherList: []
    }
  },

  computed: {
    ...mapGetters(["isManager", "klassList", "teacherInfo"]),
    canUpdate() {
      if (this.isManager) {
        return true
      }

      if (this.teacherInfo.id === this.$route.query.id) {
        return true
      }
      return false
    },

    showDelete() {
      if (!this.isManager) {
        return false
      }

      if (this.klassTeacherList.length === 1 && !this.klassTeacherList[0].id) {
        return false
      }

      return true
    },

    hasTeacherInfoChange() {
      return JSON.stringify(this.originTeacherDetail) !== JSON.stringify(this.teacherDetail)
    },

    hasTeacherChange() {
      const klassTeacherList = this.klassTeacherList.filter(item => (item.role_id || item.klass_id) && !item.id)
      return klassTeacherList.length > 0
    }
  },

  created() {
    this.initHandle()
  },

  methods: {
    initHandle() {
      this.teacherInfoId = this.$route.query.id
      this.getTeacherInfoHandle()
      this.getTeacherRoleListHandle()
      this.$store.dispatch("getKlassListService").then(klassList => {
        if (this.isManager) {
          this.curKlassList = klassList
          this.getTeacherList()
        }
      })

      if (!this.teacherInfoId) {
        this.clickHandle()
      }
    },
    getTeacherList() {
      TeacherInfoService.getTeacherInfoListService({
        school_id: this.teacherInfo.school_id,
        isManager: true
      }).then((res = []) => {
        this.teacherList = res.filter(item => item.is_active)
      })
    },

    getTeacherInfoHandle(type) {
      if (!this.teacherInfoId) return
      TeacherInfoService.getTeacherInfoService({
        teacher_info_id: this.teacherInfoId
      }).then(res => {
        if (!type || type === "teacherInfo") {
          this.teacherDetail = res
          this.originTeacherDetail = JSON.parse(JSON.stringify(res))
        }

        const klassTeacherList = res.teachers.filter(item => (!item.role || item.role.name !== "管理员") && item.klass)

        if (!type || type === "klassTeacher") {
          this.klassTeacherList = klassTeacherList.map(item => {
            return {
              id: item.id,
              name: item.name,
              klass_id: item.klass.id,
              klass_name: item.klass.name,
              role_name: item.role.name,
              role_id: item.role.id
            }
          })
        }

        if (!this.isManager) {
          this.roleList = klassTeacherList.map(item => item.role)
          this.curKlassList = klassTeacherList.map(item => item.klass)
        } else {
          this.getMatchedTeacherUser()
        }
      })
    },

    getTeacherRoleListHandle() {
      if (!this.isManager) return
      TeacherInfoService.getTeacherRoleListService({
        school_id: this.teacherInfo.school_id
      }).then(res => {
        this.roleList = res.filter(item => item.permission === "TEACHER")
      })
    },

    clickHandle() {
      this.klassTeacherList.push({
        klass_id: undefined,
        role_id: undefined,
        name: undefined
      })
    },

    delHandle(index) {
      this.klassTeacherList.splice(index, 1)
    },

    submitHandle() {
      if (this.loading) return
      const { name, mobile, gender, birth_date, has_teacher_qualification = false, entry_date, education_level, professional_title } = this.teacherDetail

      if (!name || !name.trim().length) {
        this.$message.warning("老师姓名不能为空")
        return
      }
      if (!mobile || !mobile.trim().length) {
        this.$message.warning("老师手机号不能为空")
        return
      }

      if (mobile.trim().length !== 11) {
        this.$message.warning("老师手机号格式不正确")
        return
      }

      if (this.checkDuplicateInfo(name.trim(), "name")) {
        this.$message.warning("该姓名对应的老师已存在，请修改后重试")
        return
      }

      if (this.checkDuplicateInfo(mobile.trim())) {
        this.$message.warning("该手机号对应的老师已存在，请修改后重试")
        return
      }

      const params = {
        gender,
        education_level,
        has_teacher_qualification,
        name: name.trim(),
        mobile: mobile.trim(),
        school_id: this.teacherInfo.school_id,
        teacher_info_id: this.teacherInfoId,
        professional_title: (professional_title || "").trim()
      }

      if (birth_date) {
        params.birth_date = moment(birth_date).format()
      }
      if (entry_date) {
        params.entry_date = moment(entry_date).format()
      }

      if (this.teacherInfoId) {
        this.updateTeacherHandle(params)
        return
      }
      const klassTeacherList = []
      let status = true
      this.klassTeacherList.forEach(item => {
        item.klassMessage = ""
        item.roleMessage = ""
        if (item.klass_id && item.role_id) {
          klassTeacherList.push(item)
        } else if (item.role_id && !item.klass_id) {
          status = false
          item.klassMessage = "任教班级不可为空"
        } else if (!item.role_id && item.klass_id) {
          status = false
          item.roleMessage = "任教职务不可为空"
        }
      })

      if (!status) {
        this.$forceUpdate()
        return
      }

      klassTeacherList.forEach(item => {
        item.name = params.name
        item.school_id = this.teacherInfo.id
      })

      params.teachers = klassTeacherList

      this.loading = true
      TeacherInfoService.createTeacherInfoService(params)
        .then(() => {
          this.$router.back()
        })
        .catch(() => {
          this.$message.error("操作失败，请检查后重试")
          this.loading = false
        })
    },

    async updateTeacherHandle(params) {
      this.loading = true
      if (params.mobile !== this.originTeacherDetail.mobile) {
        await TeacherInfoService.updateTeacherMobileService({
          teacherId: this.teacherInfoId,
          mobile: params.mobile
        })
      }
      TeacherInfoService.updateTeacherInfoService(params)
        .then(() => {
          this.$message.success("操作成功")
          this.resetTeacherInfo()
          this.getTeacherInfoHandle("teacherInfo")
          this.loading = false
        })
        .catch(() => {
          this.$message.error("更新失败，请检查后重试")
          this.loading = false
        })
    },

    createKlassTeacherHandle() {
      const request = []
      let status = true
      this.klassTeacherList.forEach(item => {
        item.klassMessage = ""
        item.roleMessage = ""
        if (item.role_id && item.klass_id && !item.id) {
          request.push(
            TeacherInfoService.createKlassTeacherService({
              klass_id: item.klass_id,
              role_id: item.role_id,
              name: this.teacherDetail.name,
              school_id: this.teacherInfo.school_id,
              user_id: (this.matchedUser || {}).id,
              teacher_info_id: this.teacherInfoId
            })
          )
        } else if (item.role_id && !item.klass_id) {
          status = false
          item.klassMessage = "任教班级不可为空"
        } else if (!item.role_id && item.klass_id) {
          status = false
          item.roleMessage = "任教职务不可为空"
        }
      })

      if (!status || !request.length) {
        this.$forceUpdate()
        return
      }

      this.loading = true
      Promise.all(request)
        .then(() => {
          this.$message.success("操作成功")
          this.getTeacherInfoHandle("klassTeacher")
          this.loading = false
        })
        .catch(() => {
          this.$message.error("添加失败，请检查后重试")
          this.loading = false
        })
    },

    deactivateKlassTeacherHandle(klassTeacher, index) {
      if (!klassTeacher.id) {
        this.klassTeacherList.splice(index, 1)
        return
      }
      this.$confirm({
        title: "提示信息",
        content: `是否禁用当前任教信息 ${klassTeacher.name}`,
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          return new Promise(async (resolve, reject) => {
            TeacherInfoService.deactivateKlassTeacherService({
              teacherId: klassTeacher.id
            })
              .then(() => {
                this.$message.success("操作成功")
                this.klassTeacherList.splice(index, 1)

                if (!this.klassTeacherList.length && !this.teacherInfoId) {
                  this.clickHandle()
                }
                resolve()
              })
              .catch(() => {
                reject()
                this.$message.error("操作失败，请重新操作")
              })
          })
        }
      })
    },

    delTeacherHandle() {
      this.$confirm({
        title: "提示信息",
        content: `是否删除当前任教老师 ${this.teacherDetail.name}`,
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          return new Promise(async (resolve, reject) => {
            TeacherInfoService.deactivateTeacherInfoService({
              teacherInfoId: this.teacherInfoId
            })
              .then(() => {
                this.$message.success("操作成功")
                this.$router.back()
                resolve()
              })
              .catch(() => {
                reject()
                this.$message.error("操作失败，请重新操作")
              })
          })
        }
      })
    },

    getMatchedTeacherUser(origin) {
      if (!this.isManager) return
      const mobile = this.teacherDetail.mobile
      if (!mobile || !mobile.trim()) {
        this.$message.warning("老师手机号不能为空")
        return
      }
      if (mobile.trim().length !== 11) {
        this.$message.warning("老师手机号格式不正确")
        return
      }
      if (origin === "init" && this.checkDuplicateInfo(mobile.trim())) {
        this.$message.warning("该手机号对应的老师已存在，请修改后重试")
        return
      }

      userService
        .getMatchedTeacherUserService({ mobile: mobile.trim() })
        .then(res => {
          this.matchedUser = res
          this.tips = res ? "" : "手机号暂无匹配用户"
        })
        .catch(() => {
          this.matchedUser = null
          this.tips = "手机号暂无匹配用户"
        })
    },

    resetTeacherInfo() {
      this.isEditTeacher = false
      this.teacherDetail = JSON.parse(JSON.stringify(this.originTeacherDetail))
    },

    checkDuplicateInfo(value, type = "mobile") {
      const flag = this.teacherList.find(item => item[type] === value)

      return Boolean(flag)
    },

    checkDuplicateHandle() {
      const name = this.teacherDetail.name
      if (!name || !name.trim().length) return false
      if (this.checkDuplicateInfo(name.trim(), "name")) {
        this.$message.warning("该姓名对应的老师已存在，请修改后重试")
      }
    }
  }
}
</script>
  
<style lang="less" scoped>
.teacher {
  &-container {
    padding-right: 100px;
    // padding-bottom: 30px;
    background: #f0f2f5;
    color: #303233;

    /deep/.ant-input-disabled {
      box-shadow: none;
    }
  }

  &-title {
    display: flex;
    flex-flow: nowrap row;
    align-items: center;
    height: 32px;
    padding: 15px 0;
    box-sizing: content-box;
    line-height: 32px;
    background: #f0f2f5;

    &::before {
      position: relative;
      top: -2px;
      display: inline-block;
      content: "";
      width: 6px;
      height: 6px;
      margin-right: 8px;
      background: #409eff;
      border-radius: 50%;
    }
  }

  &-info {
    min-height: 380px;
    padding: 0 0 0 60px;
    border-radius: 8px;
    background: #ffffff;

    &_edit {
      min-height: 205px;
    }
  }

  &-label {
    display: block;
    height: 20px;
    margin: 22px 0 14px;
    font-size: 14px;
    color: #343c6a;
  }

  &-input {
    width: 400px;
    height: 32px;
    border-radius: 4px;
    border-color: #d5d5d5;
  }

  &-select {
    width: 540px;
    height: 32px;
    border-radius: 4px;
    border-color: #d5d5d5;
  }

  &-kinsfolk {
    // min-height: 120px;
    padding: 10px 80px 30px 60px;
    border-radius: 8px;
    background: #ffffff;
  }

  &-btn {
    border-radius: 8px;
  }

  &-operate {
    float: right;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    text-align: center;
    color: #ffffff;
    line-height: 40px;
    cursor: pointer;
  }

  &-del {
    background: #fe5c73;
  }

  &-deliver {
    height: 1px;
    margin: 25px 0 10px;
    background: #d4d4d4;
  }

  &-item {
    width: 400px;

    &_label {
      display: inline-block;
      width: 120px;
      height: 20px;
      margin: 22px 0 5px;
      font-size: 14px;
      line-height: 20px;
      color: #343c6a;
      font-weight: bold;
    }
  }

  &-matched {
    margin-left: 20px;
    color: #62d256;
  }

  &-unmatched {
    margin-left: 20px;
    color: #ffc60a;
  }

  &-error {
    margin-left: 10px;
    color: red;
  }
}

@media screen and (max-width: 1980px) {
  .teacher-input {
    width: 300px;
  }
}

@media screen and (max-width: 1440px) {
  .teacher-input {
    width: 220px;
  }
}
</style>

<style>
</style>
